import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
    CnCommissionRuleObjectBaseViewComponent
} from '../cn-commission-rule-object-base-view/cn-commission-rule-object-base-view.component';

/**
* Full (left-nav) view of the CommissionRule object component (FR-4).
*
* Left-nav sections: Allgemein / Staffeln / Bedingungen / Cap / LogicHook /
* Haftung-Kaution / Vorschau. Each section is metadata-driven CRUD of the related
* entity, server-paged; Vorschau hosts the cn-rule-preview (FR-17).
*/
@Component({
    selector: 'mvs-cn-commission-rule-full',
    templateUrl: './cn-commission-rule-full.component.html',
    styleUrls: ['./cn-commission-rule-full.component.scss'],
    standalone: false
})
export class CnCommissionRuleFullComponent extends CnCommissionRuleObjectBaseViewComponent
    implements OnInit, OnChanges, OnDestroy {

    constructor(protected override activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    /**
    * Left-nav items (G6: action-based, fa-solid icons, German labels with umlauts).
    */
    loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Allgemein',
                action: 'cn.CommissionRule',
                tooltip: 'Allgemein',
                icon: 'fa-solid fa-sliders text-xl',
                toggleable: false,
                default: true
            },
            {
                label: 'Staffeln',
                action: 'cn.CommissionRuleTier',
                tooltip: 'Staffeln',
                icon: 'fa-solid fa-layer-group text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Bedingungen',
                action: 'cn.CommissionCondition',
                tooltip: 'Bedingungen',
                icon: 'fa-solid fa-filter-circle-dollar text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Cap',
                action: 'cn.CommissionCap',
                tooltip: 'Cap',
                icon: 'fa-solid fa-gauge-high text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'LogicHook',
                action: 'cn.CommissionLogicHook',
                tooltip: 'LogicHook',
                icon: 'fa-solid fa-plug text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Haftung/Kaution',
                action: 'cn.CommissionLiabilityTemplate',
                tooltip: 'Haftung und Kaution',
                icon: 'fa-solid fa-shield-halved text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Vorschau',
                action: 'preview',
                tooltip: 'Regel-Vorschau',
                icon: 'fa-solid fa-flask text-xl',
                toggleable: false,
                default: false
            }
        ];
    }

    override ngOnInit(): void {
        this.loadSideBarMenuItems();
        this.initComponent();
        super.ngOnInit();
    }

    /**
    * Re-render the section widgets when the bound objectIdentifier changes.
    * Delegates to the shared base view (G2.3 / G4.6).
    */
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
